import "./tutorial.scss";

import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Popover, PopoverBody } from "reactstrap";

import { appStateOperations } from "../../modules/appState";
import { tutorialOperations, tutorialSelectors } from "../../modules/tutorial";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import preprocessorQuery from "../../utils/preprocessorQuery";

let tutorialNotificationTimer;
const clickWasNotification = e => hasAncestorOfClass(e.target, "tutorialPopoverLabel");

const isIos = preprocessorQuery.isIos();

class TutorialPopoverLabel extends Component {
  constructor(props) {
    super(props);

    this.state = { tutorialShouldNotify: false };

    this.onWindowClick = this.onWindowClick.bind(this);

    this._closeOnClick = false;
  }

  componentDidMount() {
    if (isIos) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ tutorialShouldNotify: this.props.tutorialShouldNotify });
    }

    window.addEventListener("mousedown", this.onWindowClick);
    tutorialNotificationTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentWillReceiveProps(nextProps) {
    if (isIos && this.props.tutorialShouldNotify !== nextProps.tutorialShouldNotify) {
      this.setState({ tutorialShouldNotify: nextProps.tutorialShouldNotify });
    }
  }

  componentDidUpdate() {
    clearTimeout(tutorialNotificationTimer);
    tutorialNotificationTimer = setTimeout(() => {
      this._closeOnClick = true;
    }, 3000);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.onWindowClick);
    clearTimeout(tutorialNotificationTimer);
  }

  onWindowClick = e => {
    const clickedNotification = clickWasNotification(e);
    if (this._closeOnClick && !clickedNotification) {
      this.props.onCloseClick();
    } else if (clickedNotification) {
      this.props.toggleTutorial();
      this.props.onCloseClick();
    }
  };

  render() {
    const popoverPlacement = this.props.popoverPlacement ? this.props.popoverPlacement : "right-start";

    return (
      <Popover
        placement={popoverPlacement}
        className="tutorialPopoverLabel"
        target={this.props.target}
        trigger="click"
        isOpen={this.state.tutorialShouldNotify}
        boundariesElement="viewport"
      >
        <PopoverBody>
          <div className={`tutorialPopoverLabelTooltip ${popoverPlacement ? popoverPlacement : ""}`}>
            Welcome! Start with a tutorial here
          </div>
        </PopoverBody>
      </Popover>
    );
  }
}

TutorialPopoverLabel.propTypes = {
  tutorialShouldNotify: PropTypes.bool,
  onCloseClick: PropTypes.func.isRequired,
  toggleTutorial: PropTypes.func.isRequired,
  popoverPlacement: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    tutorialShouldNotify: tutorialSelectors.getTutorialShouldShowTooltip(state.present)
  };
};

const readonlyActions = {};

const editingActions = {
  onCloseClick: tutorialOperations.setTutorialTooltipShown,
  toggleTutorial: appStateOperations.toggleTutorial
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TutorialPopoverLabel);
